/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Url_InvalidInputs */

const en_validation_url_invalid = /** @type {(inputs: Validation_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid URL starting with https://.`)
};

const de_validation_url_invalid = /** @type {(inputs: Validation_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine gültige URL an, beginnend mit https://.`)
};

/**
* | output |
* | --- |
* | "Please enter a valid URL starting with https://." |
*
* @param {Validation_Url_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const validation_url_invalid = /** @type {((inputs?: Validation_Url_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Url_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_validation_url_invalid(inputs)
	return en_validation_url_invalid(inputs)
});